var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.692 1.27301L20.5205 6.19851C20.819 6.38601 21 6.71401 21 7.06651V16.444C21 16.79 20.8225 17.1115 20.5295 17.2955L12.686 22.225C12.4175 22.394 12.077 22.398 11.8045 22.236L3.49 17.2915C3.299 17.178 3.1545 17.006 3.0735 16.8065C3.0255 16.6885 3 16.561 3 16.43V7.06851C3 6.71601 3.1855 6.38951 3.489 6.20901L11.8105 1.26151C12.083 1.09951 12.4235 1.10401 12.692 1.27301Z",
    fill: "url(#paint0_linear_1005_7087)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 11.4995L20.8982 16.8745C20.8147 17.0375 20.6922 17.178 20.5302 17.2955L12.7127 22.2095C12.4097 22.3905 12.0992 22.41 11.7797 22.2225L3.49072 17.2915C3.29922 17.176 3.15822 17.0165 3.07422 16.8065L12.5007 11.4995Z",
    fill: "url(#paint1_linear_1005_7087)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 1.14618V11.5892L3.07351 16.8067C3.02351 16.6807 2.99951 16.5552 3.00001 16.4302V7.06868C3.02101 6.74068 3.11851 6.43518 3.48901 6.20918L11.8545 1.23868C11.993 1.17468 12.125 1.14018 12.248 1.14618Z",
    fill: "url(#paint2_linear_1005_7087)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2639 7.99939L11.7399 11.8359C11.9039 11.9324 12.0049 12.1084 12.0049 12.2989L11.9994 20.4759C11.9994 21.0284 12.7329 21.2209 13.0039 20.7394L20.0009 7.78389C20.2024 7.42589 19.9434 6.98389 19.5329 6.98389L4.5354 6.99989C3.9884 6.99989 3.7924 7.72239 4.2639 7.99939Z",
    fill: "#E0E0E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1005_7087",
    x1: 15.451,
    y1: 17.8605,
    x2: 8.257,
    y2: 5.11251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1005_7087",
    x1: 13.5612,
    y1: 20.9035,
    x2: 10.5447,
    y2: 13.1215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F979E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1005_7087",
    x1: 9.31051,
    y1: 11.8997,
    x2: 4.42451,
    y2: 3.24218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#90989F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.897c7a655eb96feffedcdfda79d22b21.svg";
export { ForwardRef as ReactComponent };